export type StartupErrorKind = 'network' | 'forbidden' | 'server' | 'unknown';

export interface StartupError {
  kind: StartupErrorKind;
  message: string;
}

const getStatus = (error: unknown): number | undefined => {
  if (typeof error === 'object' && error !== null) {
    const status = (error as { status?: unknown }).status;
    if (typeof status === 'number') return status;
  }
  return undefined;
};

export const classifyStartupError = (error: unknown): StartupError => {
  const status = getStatus(error);

  if (status === undefined) {
    return { kind: 'network', message: 'Can’t reach the server — it may be offline.' };
  }
  if (status === 403) {
    return {
      kind: 'forbidden',
      message: 'Some data couldn’t be loaded — you may not have access to it.'
    };
  }
  if (status >= 500) {
    return { kind: 'server', message: 'The server had a problem loading your data.' };
  }
  return { kind: 'unknown', message: 'Something went wrong loading your data.' };
};
